module.exports = __webpack_public_path__ + "img/DSC_1908.230cafe4.JPG";